// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {get, pick} from 'lodash';
import {renderCESIconByScoreType, renderIconByScoreType} from '../utils';

interface CXFeedbackProps {
    message: any;
    answerMessage: any;
}

// Renders the feedback component depending on the CX Type
export const CXFeedback = (props: CXFeedbackProps) => {
    const {message, answerMessage} = props;
    const body = get(message, 'body');
    const answerMessageBody = get(answerMessage, 'body');
    const type = get(body, 'aspect');
    const {feedback: feedbackText, question: feedbackQuestion} = pick(body, [
        'value',
        'feedback',
        'question',
    ]);
    const {value: selectedScore} = answerMessageBody;

    const iconSize = 40;

    // Defines the color class for the NPS Circle depending on the index.
    const getNPSIndexClass = (i) => {
        return i <= 6 ? 'danger' : i > 6 && i < 9 ? 'warning' : 'success';
    };

    // Renders the feedback icon depending on the CX Type
    const renderedFeedbackIcon = () => {
        switch (type) {
            case 'nps':
                return (
                    <div
                        className={`message-cx__feedback-icon-nps-circle ${getNPSIndexClass(
                            selectedScore,
                        )}`}
                    >
                        <span>{selectedScore}</span>
                    </div>
                );
            case 'ces':
                return renderCESIconByScoreType(
                    selectedScore,
                    iconSize,
                    `message-cx__feedback-icon-csat`,
                    true,
                );
            case 'csat':
                return renderIconByScoreType(
                    selectedScore,
                    iconSize,
                    `message-cx__feedback-icon-ces`,
                    true,
                );
        }
    };

    return (
        <div className="message-cx__container">
            <div className="message-cx__feedback-question-container">
                <div className="message-cx__feedback-icon-wrapper">
                    {renderedFeedbackIcon()}
                </div>
                <div className="message-cx__feedback-question-wrapper">
                    <span className="message-cx__feedback-question">
                        {feedbackQuestion}
                    </span>
                </div>
            </div>
            <div className="message-cx__feedback-user-container">
                <span className="message-cx__feedback-user-message">
                    {feedbackText}
                </span>
            </div>
        </div>
    );
};
